import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import MembersDirectory from "@/pages/MembersDirectory";
import ChartTracker from "@/pages/ChartTracker";
import MemberProfile from "@/pages/MemberProfile";
import InvitePage from "@/pages/InvitePage";
import PacketPage from "@/pages/PacketPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/members" element={<MembersDirectory />} />
          <Route path="/tracker" element={<ChartTracker />} />
          <Route path="/member/:name" element={<MemberProfile />} />
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/packet" element={<PacketPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
